
var stache = require('can/view/stache/stache');
module.exports = stache("{{{svg}}}");